var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiamondBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "16px",
    viewBox: "0 0 23 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDiamondBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-profile-Opnened-in-Jquery-enviroments",
    transform: "translate(-248.000000, -453.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1.000000, 341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First-description"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platinum-Diamond-",
    transform: "translate(247.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-99",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PlatinumDiamond",
    transform: "translate(0.000000, 1.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4861497,1 L17.3069061,4 L20.8633898,4 L17.8982301,1 L15.4861497,1 Z M14.3163846,1 L8.84068821,1 L6.89339276,4 L16.137141,4 L14.3163846,1 Z M7.64849324,1 L4.8384073,1 L2.08206165,4 L5.7011978,4 L7.64849324,1 Z M13.4821489,11.9218264 L20.6932064,5 L17.2732357,5 L13.4821489,11.9218264 Z M9.48649076,11.8645683 L5.72676431,5 L2.31014451,5 L9.48649076,11.8645683 Z M6.86692907,5 L11.5,13.4591345 L16.1330709,5 L6.86692907,5 Z M11.8813848,14.8445271 L11.5,15.5408655 L11.0784568,14.7712052 L0.30025838,4.461268 L4.39919061,9.66338121e-13 L18.3158691,9.66338121e-13 L22.7122719,4.44806002 L11.8813848,14.8445271 Z",
    id: "icDiamondBlack"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamondBlack);
export default __webpack_public_path__ + "static/media/icDiamondBlack.a576f7ecd5df5812894b7a3fec5461a4.svg";
export { ForwardRef as ReactComponent };